import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Home, Heart, MapPin, QrCode, User, Store } from 'lucide-react';

const BottomNav = () => {
  const { user } = useAuth();
  const location = useLocation();
  const isOwner = user?.role === 'owner';

  const navItems = isOwner 
    ? [
        { path: '/', icon: Store, label: 'Negocios' },
        { path: '/scan', icon: QrCode, label: 'Escanear', special: true },
        { path: '/profile', icon: User, label: 'Perfil' },
      ]
    : [
        { path: '/', icon: Home, label: 'Inicio' },
        { path: '/favorites', icon: Heart, label: 'Favoritos' },
        { path: '/scan', icon: QrCode, label: 'Escanear', special: true },
        { path: '/nearby', icon: MapPin, label: 'Cercanos' },
        { path: '/profile', icon: User, label: 'Perfil' },
      ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-800 border-t border-gray-100 dark:border-gray-700/40 shadow-lg dark:shadow-black/40 z-50">
      <div className="max-w-lg mx-auto flex items-center justify-around h-16 px-2">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          const Icon = item.icon;

          if (item.special) {
            return (
              <NavLink
                key={item.path}
                to={item.path}
                className="flex flex-col items-center justify-center -mt-6"
              >
                <div className="w-14 h-14 bg-gradient-to-r from-teal-500 to-emerald-600 rounded-full flex items-center justify-center shadow-lg">
                  <Icon className="w-6 h-6 text-white" />
                </div>
              </NavLink>
            );
          }

          return (
            <NavLink
              key={item.path}
              to={item.path}
              className="flex flex-col items-center justify-center py-2 px-3 min-w-[60px]"
              data-testid={`nav-${item.label.toLowerCase()}`}
            >
              <Icon 
                className={`w-6 h-6 transition-colors ${
                  isActive ? 'text-teal-500' : 'text-gray-400 dark:text-gray-500'
                }`} 
              />
              <span 
                className={`text-xs mt-1 font-medium transition-colors ${
                  isActive ? 'text-teal-500' : 'text-gray-400 dark:text-gray-500'
                }`}
              >
                {item.label}
              </span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
